
<template>
    <section class="supervisor-feedback">
        
        <div class="panel" v-if="!selectedSubmission">            
            <div class="panel-heading"><h2>Assignment Feedback <a class="instructions" title="View instructions" href="https://ttto-utility-bucket.s3.us-west-2.amazonaws.com/POR-Portal+Feedback+Instructions-240226-182629.pdf" target="_blank"><i class="fa fa-question-circle-o"></i></a></h2></div>
            <div class="panel-body feedback" v-if="terms">
                <div class="selects">
                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" >
                                <label>Your Terms</label>
                                <select class="form-control" v-model="selected.term" @change="getInstructorCourses">
                                    <option value="" default disabled selected>Select Term</option>
                                    <option v-for="term in terms" v-bind:value="term.id">
                                        {{term.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" v-if="courses">
                                <label>Your Courses</label>
                                <select class="form-control" v-model="selected.instance" @change="getCourse">
                                    <option default disabled selected value="">Select Course</option>
                                    <option 
                                        v-if="isInPathAndFocus(course)"
                                        v-for="course in courses"
                                        v-bind:value="course.id">
                                        {{course.associated.name}}            

                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" v-if="assignments">
                                <label>Assignments</label>                                

                                <select 
                                    v-if="assignments.length > 0" 
                                    class="form-control" 
                                    v-model="selected.assignment" v-on:change="getSubmissions">
                                    <option v-for="assignment in assignments" v-bind:value="assignment.id">
                                        Week {{assignment.week}}: {{assignment.name}} 
                                    </option>
                                </select>
                                <div v-else class="no-assignments">
                                    <p>No assignments found for this course.</p>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
                <div class="assignments" v-if="students">
                   
                    <div class="panel-heading"><h2>Submissions
                        <button @click.prevent="uploadAllFeedback()" :disabled="uploading">Upload all feedback</button>
                        <div v-if="downloadingAll" class="download-progress-wrapper">
                            <span class="download-stage">{{ downloadStage }}</span>
                            <div class="download-progress">
                                <div class="download-progress-bar" :style="{ width: downloadProgress + '%' }"></div>
                                <span class="download-progress-text">{{ downloadProgress }}%</span>
                            </div>
                        </div>
                        <span v-else class="download-buttons">
                            <button @click.prevent="downloadAllSubmissions(false)">Download all</button>
                            <button @click.prevent="downloadAllSubmissions(true)">Download latest</button>

                        </span>

                    </h2></div>
                    <ul class="students">
                        <li v-for="student in students" class="student">
                            <div class="student-header">
                                <h4>
                                   <router-link  
                                        v-if="student.submissions && student.submissions.length" 
                                        target="_blank"
                                        :to="{ name: 'student', params: { studentId: student.studentId }, 
                                        query: {userId: student.submissions[0].student.id, term: selected.term}}">
                                        {{student.firstName}} {{student.lastName}}
                                    </router-link>                                    
                                    <span v-else>{{student.firstName}} {{student.lastName}}</span>
                                </h4>
                            </div>
                            <ul class="submissions">
                                <li v-for="submission in student.submissions">                                     
                                    <div class="student-submission">
                                        <div class="submission">     

                                            <span>Submitted {{submission.createdAt | longDate}} <i v-if="submission.grade || submission.grade === 0"> - Grade: {{submission.grade}}%</i> 
                                                <span class="video-buttons">
                                                    <a href="#" @click.prevent="toggleComments(submission.id)"><i class="fa fa-comments" :class="{'open':displayedComments.includes(submission.id)}" title="View comments"></i></a>
                                                    <a title="Record feedback" href="#" @click.prevent="selectSubmission(submission)"><i class="fa fa-video-camera" title="Record feedback"></i></a>
                                                    <label class="file-upload" title="Upload video">
                                                        <i class="fa fa-upload"></i>
                                                        <input type="file" 
                                                            class="hidden"                                                         
                                                            accept="video/mp4,video/webm"                                                         
                                                            @change="uploadExternalVideo($event, submission)" />

                                                    </label>
                                                    <!-- Allow editing grade if the submission is overdue, or if it already has feedback (indicating the grader has already submissed something) -->
                                                    <a href="#" 
                                                        v-if="!submission.newFeedback && termIsOngoing && (isOverdue(submission) || submission.feedbacks && submission.feedbacks.length)" 
                                                        @click.prevent="gradeOnlyFeedback.submission = submission">
                                                        <i class="fa fa-edit" title="Grade submission without feedback"></i>
                                                    </a>
                                                    </span>
                                            </span>
                                            
                                            <span v-if="submission.downloading" class="download-progress-wrapper submission-download">
                                                <span class="download-stage">{{ submission.downloadStage }}</span>
                                                <div class="download-progress">
                                                    <div class="download-progress-bar" :style="{ width: submission.downloadProgress + '%' }"></div>
                                                    <span class="download-progress-text">{{ submission.downloadProgress }}%</span>
                                                </div>
                                            </span>
                                            <span v-if="!submission.downloading && submission.url && submission.url.length" class="urls">
                                                <a href="#" @click.prevent="downloadSubmissionFiles(submission)" class="btn btn-success control-btn">
                                                    Download all <i class="fa fa-download"></i>
                                                </a>                                  
                                                <a v-for="(url,$index) in submission.url"
                                                    :href="isImageUrl(url) ? '#' : url"
                                                    :target="isImageUrl(url) ? null : '_blank'"
                                                    @click="isImageUrl(url) ? downloadFile(url, $event) : null">
                                                    Download {{$index + 1}}
                                                    <i class="fa fa-download"></i>
                                                </a>  
                                                
                                            </span>
                                        </div>

                                        <div class="feedback-buttons">                                            
                                            <span v-if="submission.feedbacks && submission.feedbacks.length">
                                                <a title="Watch feedback" v-for="feedback in submission.feedbacks" :href="feedback.body" target="_blank">
                                                    Feedback  ({{feedback.createdAt | monthAndDay}})
                                                    <i class="fa fa-share" aria-hidden="true"></i>                                        
                                                </a>
                                            </span>                                            
                                        </div>

                                    </div>
                                    <div v-if="displayedComments.includes(submission.id)">
                                        <div class="comments-box" v-if="submission.comments">{{submission.comments.trim()}}</div>
                                        <div class="supervisor-comments" v-if="submission.supervisorComments && submission.supervisorComments.length">
                                            <div class="comments-box" v-for="comment in submission.supervisorComments" v-html="comment"></div>
                                        </div>
                                        <div class="supervisor-comment">
                                            <textarea v-model="submission.supervisorComment" placeholder="Enter any comments here" class="form-control"></textarea>
                                            <button class="btn btn-success control-btn" @click.prevent="saveSupervisorComment(submission)">Save Comment</button>

                                        </div>
                                    </div>
                                    <div v-if="submission.newFeedback" class="new-feedback-wrapper">
                                        <video class="new-feedback" :src="submission.newFeedback.body" controls></video>
                                        <div class="form-group">
                                            <input type="number" v-model="submission.newFeedback.grade" placeholder="Enter Grade (%)" class="form-control" min="0" max="100" :readonly="uploading" />
                                        </div>
                                        <label class="checkbox-wrapper">
                                            <input type="checkbox" v-model="submission.applyToAll">
                                            Apply to all submissions for this student in all courses this week?
                                        </label>
                                        <div class="buttons">
                                            <button class="btn btn-success" @click.prevent="uploadSingleFeedback(submission)" :disabled="uploading">Upload <i class="fa fa-upload"></i></button>
                                            <button class="btn btn-error" @click.prevent="discardRecording(student.studentId, submission.id)" :disabled="uploading">Discard <i class="fa fa-trash"></i></button>                                    
                                            <button class="btn btn-primary" @click.prevent="downloadRecording(submission)">Download <i class="fa fa-download"></i></button>                                        
                                        </div>                                    </div>
                                    <div v-if="gradeOnlyFeedback.submission && gradeOnlyFeedback.submission.id === submission.id" class="grade-only-feedback">
                                        
                                        <div class="form-group radio-inputs">
                                            <label>
                                                <input type="radio" v-model="gradeOnlyFeedback.videoType" value="placeholderVideo">
                                                Use placeholder video
                                            </label>
                                            <label v-if="submission.feedbacks && submission.feedbacks.length">
                                                <input type="radio" v-model="gradeOnlyFeedback.videoType" value="previousVideo">
                                                Use previous feedback video
                                            </label>                                            
                                        </div>
                                        <div class="form-group">
                                            <input type="number" v-model="gradeOnlyFeedback.grade" placeholder="Enter Grade (%)" class="form-control" min="0" max="100" :readonly="uploading" />
                                        </div>
                                        <div class="form-group buttons">
                                            <button class="btn btn-success" @click.prevent="submitGradeOnlyFeedback(submission)" :disabled="uploading || gradeOnlyFeedback.grade === null">Submit Grade <i class="fa fa-upload"></i></button>
                                            <button class="btn btn-error" @click.prevent="gradeOnlyFeedback.submission = null; gradeOnlyFeedback.grade = null; gradeOnlyFeedback.videoType = 'placeholderVideo'" :disabled="uploading">Cancel <i class="fa fa-times"></i></button>                                                                            
                                        </div>

                                    </div>
                                    
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <div class="upload-all-wrapper">
                        <button @click.prevent="uploadAllFeedback()" class="btn btn-success" :disabled="uploading">Upload all feedback</button>
                    </div>
                </div>
                <div class="assignments no-students" v-else>
                    <div class="panel-heading"><h2>Submissions</h2></div>
                    <h4>Please select a term, course, and assignment to view submissions</h4>
                </div>
            </div>
        </div>
        <div class="recorder" v-show="selectedSubmission">
            <div class="overlay audio-source" v-if="showAudioSourceModal" @click.prevent="showAudioSourceModal = false">
                <div class="audio-source-modal" @click.stop>
                    <h5 class="">Select audio source</h5>
                    <div class="audio-sources flex-col">
                        <div
                            v-for="source in mediaDevices.availableAudioSources"
                            :key="source.deviceId"
                            @click="selectAudioSource(source)"
                            class="audio-source-item"
                            :class="{ 'selected': mediaDevices.selectedAudioSource.deviceId === source.deviceId }"
                        >
                            <i class="fa fa-microphone"></i>
                            <span>{{ source.label || 'Microphone' }}</span>
                            <i v-if="mediaDevices.selectedAudioSource.deviceId === source.deviceId" class="fa fa-check"></i>
                        </div>
                    </div>
                    <div class="buttons flex">
                        <button @click.prevent="showAudioSourceModal = false" class="btn btn-error">Cancel</button>
                        <button @click.prevent="applyAudioSource()" class="btn btn-success">Apply</button>
                    </div>
                </div>
            </div>

            <div class="controls flex align-center justify-between">
                
                <div class="left flex align-center">
                    <button @click.prevent="exitRecorder" class="btn btn-success"><i class="fa fa-arrow-left"></i>Back</button>
                    <button v-if="!isRecording && !isPaused" @click.prevent="startPreview(true)" class="btn btn-sm btn-success"><i class="fa fa-video-camera"></i>Select video source</button>
                    <button v-if="!isRecording && !isPaused" @click.prevent="openAudioSourceSelector()" class="btn btn-sm btn-success"><i class="fa fa-volume-up"></i>Select audio source</button>
                                             
                </div>
                <div class="right">     
                    <button 
                        v-if="isRecording || isPaused"
                        class="btn btn-sm btn-success"
                        @click.prevent="isPaused ? resumeRecording() : pauseRecording()">
                        <span v-if="!isPaused"><i class="ri-pause-circle-line"></i>Pause</span>
                        <span v-else><i class="ri-play-circle-line"></i>Resume</span>
                    </button>                                              
                    <button v-if="!isPaused"
                        @click.prevent="isRecording ? stopRecording() : startRecording()" 
                        class="btn btn-sm btn-success recording-button" 
                        :class="{'record': isRecording}"
                        >
                        <span v-if="isRecording" class="recording-indicator"></span>
                        <span v-if="isRecording">{{recordingTime | secondsToMs}}</span>
                        {{ isRecording ? 'Stop' : 'Start Recording' }} 

                        <i :class="isRecording ? 'ri-stop-circle-line' : 'ri-record-circle-line'"></i>
                    </button>
                    
                </div>
            </div>
            <div class="recording" :class="{'recording-frame':!previewing, 'is-recording': isRecording, 'paused': isPaused}" >
                <video ref="screenPreview" autoplay muted></video>              
                
            </div>
            
        </div>
    </section>

</template>

<script>

import axios from 'axios';
import aws from '../services/aws';
import users from '../services/users';
import feedbackStorage from '../util/feedback-storage';
import toastr from 'toastr';
import _ from 'lodash';
import * as fflate from "fflate";
import FileSaver from "../../node_modules/file-saver/dist/FileSaver.js";
import streamSaver from "streamsaver";
import moment from 'moment';

const removeDiacritics = require('diacritics').remove;

let recordingTimer;


export default {
    data() {
        return {
            terms: null,
            selected: {instance: null, assignment: null, course: null, term: null},
            myPathIds: [],
            currentTerm: null,
            courses: null,
            assignments: null,
            students: null,
            downloadingAll: false,
            uploading: false,
            downloadProgress: 0,
            downloadStage: '',
            selectedSubmission: null,
            submissionToGrade: null,
            gradeOnlyFeedback: {
                submission: null,
                videoType: 'placeholderVideo',
                grade: null
            },
            displayedComments: [],
            isRecording: false,
            isPaused: false,
            recordingTime: 0,
            recordedBlob: null,
            mediaRecorder: null,
            chunks: [],
            recordingTimer: null,
            previewing:false,
            noCamera: false,
            screenPermissionGranted: false,
            showAudioSourceModal: false,
            mediaDevices: {
                cameraPermissionGranted: false,
                microphonePermissionGranted: false,
                availableAudioSources: [],
                selectedAudioSource: null,
                currentStream: null,
                noCamera: false,
                cameraError: false,
            }
        }
    },
    components: {

    },
    created() {

    },
    mounted() {
        this.getTerms();
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);

        // Clean up media recorder and timer
        if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
            this.mediaRecorder.stop();
        }
        if (recordingTimer) {
            clearInterval(recordingTimer);
            recordingTimer = null;
        }

        // Clean up media streams
        if (this.mediaDevices.currentStream) {
            this.mediaDevices.currentStream.getTracks().forEach(track => track.stop());
            this.mediaDevices.currentStream = null;
        }

        // Clean up blob URLs from all feedback previews
        if (this.students) {
            for (const student of this.students) {
                if (student.submissions) {
                    for (const submission of student.submissions) {
                        if (submission.newFeedback && submission.newFeedback.body) {
                            URL.revokeObjectURL(submission.newFeedback.body);
                        }
                    }
                }
            }
        }

        // Clean up screen preview
        if (this.$refs.screenPreview && this.$refs.screenPreview.srcObject) {
            this.$refs.screenPreview.srcObject.getTracks().forEach(track => track.stop());
            this.$refs.screenPreview.srcObject = null;
        }
    },
    methods: {
        handleBeforeUnload(event) {
            if (this.uploading) {
                event.preventDefault();
                event.returnValue = 'Feedback is currently uploading. Are you sure you want to leave?';
                return event.returnValue;
            }
        },
        getTerms() {                                    
            const options = {
                method: 'GET',
                url: window.apiUrl + '/supervisor-terms',
                headers: { 'Authorization': 'Bearer ' + localStorage.token }
            };
            axios.request(options).then((response) => {
                const now = new Date();
                this.terms = response.data.terms.sort((a,b) => { return new Date(a.startDate) - new Date(b.startDate)});
                let currentTerm = this.terms.find((t) => { return new Date(t.startDate) < now && new Date(t.endDate) > now});
                if (currentTerm) {
                    this.selected.term = currentTerm.id;                    
                } else {
                    // If no current term, select the latest term
                    this.selected.term = this.terms[this.terms.length -1].id;                
                }
                this.getInstructorCourses();
                
            });            
        },
        async getInstructorCourses() {
          
            this.courses = null;
            this.assignments = null;
            this.students = null;

            // handle supervisors who have more than one path that they supervise
            const termGroups = await users.getGroups(this, this.selected.term);
            let myGroupIds = localStorage.group ? localStorage.group.split(',') : [];            
            myGroupIds = myGroupIds.map(g => parseInt(g));

            const myGroups = termGroups.data.groups.filter(g => myGroupIds.includes(g.id));

            const myPaths = myGroups.map(g => g.pathId).filter(i => i);
            this.myPathIds = myPaths.map(p => p.toString());
            const options = {
                method: 'GET',
                url: apiUrl + '/instructor-courses?feedback_machine=true&term=' + this.selected.term,
                headers: { 'Authorization': 'Bearer ' + localStorage.token },

            };
            axios.request(options).then((response) => {
                let courses = response.data;
                if (!Array.isArray(courses)) courses = [courses];   
                this.courses = courses.sort((a,b)=>{
                    return a.associated.name.localeCompare(b.associated.name);

                });
            });           
        },
        getCourse() {
            this.assignments = null;
            this.students = null;
            let instanceId = this.selected.instance;
            let index = this.courses.findIndex(function(c) { return c.id === instanceId });
            let courseId = this.courses[index].associated.courseId;

            const options = {
                url: apiUrl + '/assignments/' + courseId + '/' + instanceId,
                method: 'GET',
                headers: { 'Authorization': 'Bearer ' + localStorage.token }

            };

            this.assignments = null;
            this.submissions = null;
            this.selectedSubmission = null;
            axios.request(options).then((response) => {
                if (response.data) {
                    this.assignments = response.data.sort(function(a, b) { return a.week - b.week || a.name.localeCompare(b.name) });
                } else {
                    this.assignments = null;
                }
            }).catch(function(e) {
                console.log(e);
                toastr.error('Error getting assignments');
            })

        },
        async getSubmissions() {

            const options = {
                method: 'GET',
                url: window.apiUrl + '/submissions?assignment_id=' + this.selected.assignment,
                headers: { 'Authorization': 'Bearer ' + localStorage.token }
            };
            this.students = [];
            this.submissions = null;
            this.selectedStudent = null;
            this.selectedSubmission = null;

            const response = await axios.request(options);

            var students = [];

            response.data.forEach((student) => {
                let index = students.findIndex((s) => { return s.studentId === student.studentId })
                if (index === -1) {
                    students.push({
                        studentId: student.studentId,
                        firstName: student.student.firstName,
                        lastName: student.student.lastName,
                        submissions: []
                    });
                }
            });

            students = students.sort((a, b) => { return a.firstName.localeCompare(b.firstName) });

            response.data.forEach((submission) => {
                let index = students.findIndex(function(s) { return s.studentId === submission.studentId });
                students[index].submissions.push(submission);
            });

            for (const s of students) {
                const uniqueSubmissions = _.uniqBy(_.clone(s.submissions), 'id');
                for (const submission of s.submissions) {
                    const sub = uniqueSubmissions.find((u) => u.id === submission.id);
                    if (!sub.feedbacks) {
                        sub.feedbacks = [];
                    }
                    if (submission.feedback && submission.feedback.body) {
                        sub.feedbacks.push(submission.feedback);
                    }
                }
                s.submissions = uniqueSubmissions.sort((a, b) => {
                    return new Date(b.createdAt) - new Date(a.createdAt);
                });
            }

            this.students = students;
            await this.restorePendingFeedback();
        },
        async restorePendingFeedback() {
            const MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000; // 14 days
            const now = Date.now();

            try {
                const pendingFeedback = await feedbackStorage.getAllFeedback();
                let restoredCount = 0;

                for (const feedback of pendingFeedback) {
                    // Delete expired entries
                    if (now - feedback.createdAt > MAX_AGE_MS) {
                        await feedbackStorage.deleteFeedback(feedback.submissionId);
                        continue;
                    }

                    // Find the matching student and submission
                    for (const student of this.students) {
                        const submission = student.submissions.find(s => s.id === feedback.submissionId);
                        if (submission) {
                            submission.newFeedback = {
                                body: URL.createObjectURL(feedback.blob),
                                type: feedback.type,
                                blob: feedback.blob,
                                grade: null
                            };
                            restoredCount++;
                            break;
                        }
                    }
                }

                if (restoredCount > 0) {
                    this.$forceUpdate();
                }
            } catch (error) {
                console.error('Error restoring pending feedback:', error);
            }
        },
        isInPathAndFocus(course) {

            if (course.focus && localStorage.focus.indexOf(course.focus.id) > -1) {
                return true;
            } 
            if (course.paths && course.paths.length > 0) {
                let pathIds = course.paths.map(function(p) { return p.id.toString()});
                if (_.intersection(pathIds, this.myPathIds).length > 0) {
                    return true;
                }
                if (pathIds.includes(localStorage.path)) {                    
                    return true;
                }
            }
            if ((course.paths && course.paths.length > 0) || course.focus) {
                return false;
            } 
            return true;
        },
        isOverdue(submission) {
            const assignment = this.assignments.find((a) => {
                return a.id === submission.assignmentId;
            });
            if (!assignment || !assignment.dueDate) return false;
            return new Date(submission.createdAt) > new Date(assignment.dueDate);        
        },
        selectSubmission(submission) {

            this.selectedSubmission = submission;

            if (this.screenPermissionGranted) {
                this.startPreview();
            }
        },
        toggleComments(submissionId) {
            if (this.displayedComments.includes(submissionId)) {
                this.displayedComments = this.displayedComments.filter(id => id !== submissionId);
            } else {
                this.displayedComments.push(submissionId);
            }
        },
        saveSupervisorComment(submission) {
            const options = {
                method: 'POST',
                url: window.apiUrl + '/supervisor-comment',
                headers: { 'Authorization': 'Bearer ' + localStorage.token },
                data: {
                    submissionId: submission.id,
                    comment: submission.supervisorComment
                }
            };
            axios.request(options).then((response) => {
                toastr.success('Supervisor comment saved');
                if (!submission.supervisorComments) {
                    submission.supervisorComments = [];                
                }
                submission.supervisorComments.push(`<b>${localStorage.user_name}: </b> ${submission.supervisorComment}`);
                submission.supervisorComment = null;
                this.$forceUpdate();
            }).catch((error) => {
                console.error('Error saving supervisor comment:', error);
                toastr.error('Error saving supervisor comment. Please try again.');
            });

        },
        exitRecorder() {
            // Stop recording if active
            if (this.isRecording || this.isPaused) {
                if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
                    this.mediaRecorder.stop();
                }
                if (recordingTimer) {
                    clearInterval(recordingTimer);
                    recordingTimer = null;
                }
                this.isRecording = false;
                this.isPaused = false;
            }

            // Exit recorder view
            this.selectedSubmission = null;
        },
        async downloadAllSubmissions(onlyLatest = false) {
            this.downloadingAll = true;
            this.downloadProgress = 0;
            this.downloadStage = 'Preparing';

            const assignment = this.assignments.find((a) => {
                return a.id === this.selected.assignment;
            });

            const course = this.courses.find((c) => {
                return c.id === this.selected.instance;
            });

            const courseName = this.sanitizePathName(course.associated.name).replace(/[^a-zA-Z0-9 ]/g, '');
            const assignmentName = this.sanitizePathName(assignment.name).replace(/[^a-zA-Z0-9 ]/g, '');
            const weekFolder = `Week ${assignment.week}`;
            const baseFolder = `${courseName} - ${assignmentName} - ${weekFolder}`;

            // Build array of files to download
            const filesToDownload = [];

            for (const student of this.students) {
                let subs = onlyLatest ? student.submissions.slice(0, 1) : student.submissions;
                const studentName = removeDiacritics(this.sanitizePathName(`${student.firstName} ${student.lastName}`));

                for (const [idx, submission] of subs.entries()) {
                    const basePath = `${baseFolder}/${studentName}/Submission ${idx + 1}/`;

                    // Add comments file if exists
                    if (submission.comments) {
                        filesToDownload.push({
                            path: basePath + 'comments.txt',
                            content: submission.comments,
                            isText: true
                        });
                    }

                    // Add all submission files
                    for (const url of submission.url) {
                        const filename = removeDiacritics(url.split('?')[0].split('/').pop());
                        filesToDownload.push({
                            path: basePath + filename,
                            url: url,
                            isText: false
                        });
                    }
                }
            }

            const zipFilename = `${courseName} - ${assignmentName} - Week ${assignment.week}.zip`;

            let aborted = false;
            let writer = null;

            try {
                this.downloadStage = 'Starting download';

                // Create StreamSaver write stream - writes directly to disk
                const fileStream = streamSaver.createWriteStream(zipFilename);
                writer = fileStream.getWriter();

                // Create streaming zip that pipes to disk
                const zip = new fflate.Zip((err, chunk, final) => {
                    if (aborted) return;
                    if (err) {
                        writer.abort();
                        throw err;
                    }
                    writer.write(chunk).catch(() => { aborted = true; });
                    if (final) {
                        writer.close().catch(() => {});
                    }
                });

                const totalFiles = filesToDownload.length;
                let processedCount = 0;

                for (const fileInfo of filesToDownload) {
                    if (aborted) break;

                    if (fileInfo.isText) {
                        // Text content - small, no need for zip64
                        const content = fflate.strToU8(fileInfo.content);
                        const file = new fflate.ZipDeflate(fileInfo.path, { level: 6 });
                        zip.add(file);
                        file.push(content, true);
                    } else {
                        // Stream file from URL
                        const response = await fetch(fileInfo.url);
                        const contentLength = parseInt(response.headers.get('content-length') || '0', 10);

                        // Use ZipDeflate for compression, ZipPassThrough for already-compressed formats
                        const ext = fileInfo.path.split('.').pop().toLowerCase();
                        const alreadyCompressed = ['zip', 'gz', 'jpg', 'jpeg', 'png', 'gif', 'mp4', 'webm', 'mp3', 'pdf', 'bgeo.sc', 'vdb', 'abc', 'exr', 'rat'].includes(ext);

                        const file = alreadyCompressed
                            ? new fflate.ZipPassThrough(fileInfo.path)
                            : new fflate.ZipDeflate(fileInfo.path, { level: 6 });

                        // Enable ZIP64 for files > 4GB
                        if (contentLength > 0xffffffff) {
                            file.zip64 = true;
                        }

                        zip.add(file);

                        // Stream the file content
                        const reader = response.body.getReader();
                        try {
                            while (true) {
                                if (aborted) {
                                    reader.cancel();
                                    break;
                                }
                                const { done, value } = await reader.read();
                                if (done) {
                                    file.push(new Uint8Array(0), true);
                                    break;
                                }
                                file.push(value, false);
                            }
                        } catch (readError) {
                            if (!aborted) throw readError;
                        }
                    }

                    processedCount++;
                    this.downloadProgress = Math.round((processedCount / totalFiles) * 100);
                    this.downloadStage = `Processing ${processedCount}/${totalFiles}`;
                }

                // Finalize the zip if not aborted
                if (!aborted) {
                    zip.end();
                    toastr.success('Download completed!');

                }

            } catch (error) {
                if (!aborted) {
                    console.error("Error creating zip:", error);
                    toastr.error('Error creating zip file. Please try again or download individual submissions.');
                }
            } finally {
                if (aborted && writer) {
                    try { writer.abort(); } catch (e) {}
                }
                this.downloadingAll = false;
                this.downloadProgress = 0;
            }
        },
        sanitizePathName(name) {
            // Remove characters that are invalid on Windows, Mac, or Linux
            return name.replace(/[\\/:*?"<>|]/g, '').replace(/\s+/g, ' ').trim();
        },
        async downloadSubmissionFiles(submission) {
            const assignment = this.assignments.find((a) => {
                return a.id === submission.assignmentId;
            });

            const course = this.courses.find((c) => {
                return c.id === assignment.instanceId;
            });

            const student = this.students.find((s) => {
                return s.studentId === submission.studentId;
            });

            // Find submission index (1-based)
            const submissionIndex = student.submissions.findIndex(s => s.id === submission.id) + 1;

            const studentName = `${submission.student.firstName} ${submission.student.lastName}`;
            const courseName = course.associated.name;
            const assignmentName = assignment.name;

            let mainFolder = `${this.sanitizePathName(studentName)} - ${this.sanitizePathName(courseName)} - ${this.sanitizePathName(assignmentName)} - Submission ${submissionIndex}`;
            mainFolder = removeDiacritics(mainFolder).replace(/[^a-zA-Z0-9- ]/g, '');

            const zipFilename = `${mainFolder}.zip`;

            submission.downloading = true;
            submission.downloadProgress = 0;
            submission.downloadStage = 'Preparing';
            this.$forceUpdate();

            let aborted = false;
            let writer = null;

            try {
                // Build array of files to download
                const filesToDownload = [];

                // Add comments file if exists
                if (submission.comments) {
                    filesToDownload.push({
                        path: `${mainFolder}/comments.txt`,
                        content: submission.comments,
                        isText: true
                    });
                }

                // Add all submission files
                for (const url of submission.url) {
                    const filename = removeDiacritics(url.split('?')[0].split('/').pop());
                    filesToDownload.push({
                        path: `${mainFolder}/${filename}`,
                        url: url,
                        isText: false
                    });
                }

                // Create StreamSaver write stream - writes directly to disk
                const fileStream = streamSaver.createWriteStream(zipFilename);
                writer = fileStream.getWriter();

                // Create streaming zip that pipes to disk
                const zip = new fflate.Zip((err, chunk, final) => {
                    if (aborted) return;
                    if (err) {
                        writer.abort();
                        throw err;
                    }
                    writer.write(chunk).catch(() => { aborted = true; });
                    if (final) {
                        writer.close().catch(() => {});
                    }
                });

                const totalFiles = filesToDownload.length;
                let processedCount = 0;

                for (const fileInfo of filesToDownload) {
                    if (aborted) break;

                    if (fileInfo.isText) {
                        const content = fflate.strToU8(fileInfo.content);
                        const file = new fflate.ZipDeflate(fileInfo.path, { level: 6 });
                        zip.add(file);
                        file.push(content, true);
                    } else {
                        const response = await fetch(fileInfo.url);
                        const contentLength = parseInt(response.headers.get('content-length') || '0', 10);

                        const ext = fileInfo.path.split('.').pop().toLowerCase();
                        const alreadyCompressed = ['zip', 'gz', 'jpg', 'jpeg', 'png', 'gif', 'mp4', 'webm', 'mp3', 'pdf'].includes(ext);

                        const file = alreadyCompressed
                            ? new fflate.ZipPassThrough(fileInfo.path)
                            : new fflate.ZipDeflate(fileInfo.path, { level: 6 });

                        if (contentLength > 0xffffffff) {
                            file.zip64 = true;
                        }

                        zip.add(file);

                        const reader = response.body.getReader();
                        try {
                            while (true) {
                                if (aborted) {
                                    reader.cancel();
                                    break;
                                }
                                const { done, value } = await reader.read();
                                if (done) {
                                    file.push(new Uint8Array(0), true);
                                    break;
                                }
                                file.push(value, false);
                            }
                        } catch (readError) {
                            if (!aborted) throw readError;
                        }
                    }

                    processedCount++;
                    submission.downloadProgress = Math.round((processedCount / totalFiles) * 100);
                    submission.downloadStage = `Processing ${processedCount}/${totalFiles}`;
                    this.$forceUpdate();
                }

                if (!aborted) {
                    zip.end();
                }

            } catch (error) {
                if (!aborted) {
                    console.error("Error downloading files:", error);
                    toastr.error('Error creating zip file. Please try again.');
                }
            } finally {
                if (aborted && writer) {
                    try { writer.abort(); } catch (e) {}
                }
                submission.downloading = false;
                submission.downloadProgress = 0;
                this.$forceUpdate();
            }
        },
        isImageUrl(url) {
            const ext = url.split('?')[0].split('.').pop().toLowerCase();
            return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(ext);
        },
        downloadFile(url, event) {
            if (event) event.preventDefault();
            const filename = url.split('?')[0].split('/').pop();
            JSZipUtils.getBinaryContent(url, (err, data) => {
                if (err) {
                    console.error('Error downloading file:', err);
                    toastr.error('Error downloading file');
                    return;
                }
                const blob = new Blob([data]);
                FileSaver.saveAs(blob, filename);
            });
        },

        discardRecording(studentId, submissionId) {
            // confirm discard
            this.$swal({                
                text: `Please confirm that you want to discard this recording`,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                background:'#222',
                color:'#fcffff',            
                confirmButtonColor: '#33ccff',   
                customClass:'swal-white-text-visible'             
            }).then(async () => {
                const studentIndex = this.students.findIndex((s) => {
                    return s.studentId === studentId;
                });
                const submissionIndex = this.students[studentIndex].submissions.findIndex((sub) => {
                    return sub.id === submissionId;
                });
                const submission = this.students[studentIndex].submissions[submissionIndex];

                // Clean up blob, object URL, and IndexedDB entry to free memory
                if (submission.newFeedback) {
                    URL.revokeObjectURL(submission.newFeedback.body);
                }
                await feedbackStorage.deleteFeedback(submissionId);

                this.$set(this.students[studentIndex].submissions[submissionIndex], 'newFeedback', null);
                this.$forceUpdate();

            }, (dismiss) => {

            });
        },
        // startRecording(stream) {
        //     if (!this.screenPermissionGranted) {
        //         toastr.error('Screen sharing permission is required to start recording.');
        //         return;
        //     }


        //     if (this.isRecording || !stream) return;           


        //     this.isRecording = true;
        //     this.recordingTime = 0;

        //     recordingTimer = window.setInterval(() => {
        //         if (this.isRecording) {
        //             this.recordingTime += 1;
        //         }
        //     }, 1000);

        //     const mimeType = this.getSupportedMimeType();
        //     console.log('Using MIME type for recording:', mimeType);

        //     const options = {
        //         mimeType,
        //         videoBitsPerSecond: 5000000, // 5 Mbps for high quality
        //     };

        //     this.mediaRecorder = new MediaRecorder(stream, options);
        //     this.chunks = [];

        //     this.mediaRecorder.ondataavailable = (e) => {
        //         if (e.data.size > 0) this.chunks.push(e.data);
        //     };

        //     this.mediaRecorder.onstop = () => {
        //         const blob = new Blob(this.chunks, { type: mimeType });
        //         this.recordedBlob = blob;
        //         console.log(this.recordedBlob)

        //     };

        //     this.mediaRecorder.onerror = (_event) => {
        //         const error = new Error('Recording failed');
        //         console.error('Recording error:', error);
        //     };

        //     try {
        //         this.mediaRecorder.start();
        //     } catch (error) {
        //         this.isRecording = false;
        //         if (recordingTimer) {
        //             clearInterval(recordingTimer);
        //             recordingTimer = null;
        //         }
        //         console.error('Recording start error:', error);
        //     }
        // },
        async openAudioSourceSelector() {
            await this.requestAudioPermissionAndLoadSources();
            this.showAudioSourceModal = true;
        },
        selectAudioSource(source) {
            this.mediaDevices.selectedAudioSource = source;
        },
        applyAudioSource() {
            this.showAudioSourceModal = false;
            // Restart preview with new audio source
            if (this.previewing) {
                this.startPreview();
            }
        },

        async requestAudioPermissionAndLoadSources () {
            if (this.mediaDevices.microphonePermissionGranted && this.mediaDevices.availableAudioSources.length > 0) {
                return;
            }

            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                stream.getTracks().forEach(track => track.stop());
                
                this.mediaDevices.microphonePermissionGranted = true;

                const devices = await navigator.mediaDevices.enumerateDevices();
                const audioInputs = devices.filter(device => device.kind === 'audioinput');
                console.log("AUDIO INPUT")
                console.log(audioInputs)
                this.mediaDevices.availableAudioSources = audioInputs;

                if (audioInputs.length > 0 && !this.selectedAudioSource) {
                    this.mediaDevices.selectedAudioSource = audioInputs[0];
                }
            } catch (error) {
                console.log(error)
            }
        },

        async startPreview(forceNew = false) {
            this.previewing = false;
            console.log('Selected audio source:', this.mediaDevices.selectedAudioSource);

            try {
                let displayStream;

                // Check if we already have an active screen stream with live tracks
                if (!forceNew && this.mediaDevices.currentStream && this.screenPermissionGranted) {
                    const videoTracks = this.mediaDevices.currentStream.getVideoTracks();
                    const hasActiveVideoTrack = videoTracks.some(track => track.readyState === 'live');

                    if (hasActiveVideoTrack) {
                        console.log('Reusing existing screen stream');
                        // Use video-only stream for preview to prevent audio feedback
                        const videoTrack = this.mediaDevices.currentStream.getVideoTracks()[0];
                        const previewStream = new MediaStream([videoTrack]);
                        this.$refs.screenPreview.srcObject = previewStream;
                        this.$refs.screenPreview.muted = true;
                        this.$refs.screenPreview.play();
                        this.previewing = true;
                        return;
                    } else {
                        // Stream exists but tracks have ended, clean up
                        console.log('Existing stream tracks have ended, requesting new stream');
                        this.mediaDevices.currentStream = null;
                        this.screenPermissionGranted = false;
                    }
                }



                // Get display media (screen/window/tab)
                displayStream = await navigator.mediaDevices.getDisplayMedia({
                    video: {
                        displaySurface: this.selectedScreenType || 'monitor',
                    },
                    audio: true, // Request system audio if available
                });

                this.screenPermissionGranted = true;

                // Listen for when user stops sharing via browser UI
                displayStream.getVideoTracks()[0].addEventListener('ended', () => {
                    this.screenPermissionGranted = false;
                    this.mediaDevices.currentStream = null;
                    this.previewing = false;
                });

                // Stop system audio from display stream - we'll use mic audio during recording
                displayStream.getAudioTracks().forEach((track) => track.stop());

                console.log('Got display stream for preview');
                console.log('Video tracks:', displayStream.getVideoTracks());

                // Store display stream - mic audio will be added when recording starts
                this.mediaDevices.currentStream = displayStream;

                // For preview, use video-only stream (muted to prevent any audio feedback)
                this.$refs.screenPreview.srcObject = displayStream;
                this.$refs.screenPreview.muted = true;
                this.$refs.screenPreview.play();
                this.previewing = true;
            } catch (error) {
                console.error('Error accessing display media:', error);
                this.screenPermissionGranted = false;
            }
        },
        async uploadExternalVideo($event, submission) {
            const file = $event.target.files[0];

            if (!file) {
                return;
            }
            const mimeType = file.type;
            if (mimeType !== 'video/mp4' && mimeType !== 'video/webm') {
                toastr.error('Please upload a valid video file (MP4 or WEBM)');
                return;
            }
            const student = this.students.find((s) => {
                return s.studentId === submission.studentId;
            });
            const sub = student.submissions.find((sub) => {
                return sub.id === submission.id;
            });

            sub.newFeedback = {
                body: URL.createObjectURL(file),
                type: mimeType,
                grade: null,
                blob: file
            };

            // Save to IndexedDB for persistence across page refreshes
            try {
                await feedbackStorage.saveFeedback(
                    sub.id,
                    student.studentId,
                    file,
                    mimeType
                );
            } catch (error) {
                console.error('Error saving feedback to IndexedDB:', error);
            }

            this.$forceUpdate();
        },
        async uploadAllFeedback() {
            let allGraded = true;

            for (const student of this.students) {
                if (student.submissions) {
                    const isUngraded = student.submissions.find((s)=>{
                        return s.newFeedback && s.newFeedback.grade !== 0 && !s.newFeedback.grade
                    });
                    if (isUngraded) {
                        allGraded = false;
                    }
                }
            }
            if (allGraded === false) {
                toastr.error('Please add a grade to all feedback');
                return;
            }

            let allValid = true;

            for (const student of this.students) {
                if (student.submissions) {
                    for (const submission of student.submissions) {
                        if (submission.newFeedback && submission.newFeedback.grade) {
                            const valid = this.validateSubmission(submission);
                            if (!valid) {
                                allValid = false;
                            }
                        }
                    }
                }
            }
            if (allValid !== true) {
                return;
            }
            this.uploading = true;

            for (const student of this.students) {
                if (student.submissions) {
                    for (const submission of student.submissions) {
                        if (submission.newFeedback && submission.newFeedback.grade) {
                            await this.uploadFeedback(submission);
                        }
                    }
                }
            }
            this.uploading = false;
            this.getSubmissions();

        },
        validateSubmission(submission) {
            if (submission.newFeedback.grade === null || submission.newFeedback.grade === undefined || submission.newFeedback.grade === '') {
                toastr.error('Please enter a grade');
                return false;
            }

            if (submission.newFeedback.grade < 0 || submission.newFeedback.grade > 100) {
                toastr.error('Grade must be between 0 and 100');
                return false;            
            }
            return true;

        },
        async uploadSingleFeedback(submission) {              
            const valid = this.validateSubmission(submission);
            if (!valid) {
                return;            
            }
            this.uploading = true;
            if (submission.applyToAll === true) {
                const assignment = this.assignments.find((a)=>{
                    return a.id === submission.assignmentId;
                });
                const week = assignment.week;

                const allCourses = this.courses.filter((c)=>{
                    return c.assignments && c.assignments.find((a) => {
                        return a.week === week;
                    })
                });
                const allAssignments = allCourses.map(c => c.assignments).flat().filter((a)=>{
                    return a.week === week
                });

                for (const assignment of allAssignments) {
                    const submissionData = await axios.request({
                        method: 'GET',
                        url: window.apiUrl + '/submissions?assignment_id=' + assignment.id,
                        headers: { 'Authorization': 'Bearer ' + localStorage.token }
                    });

                    const studentSubmissions = submissionData.data.filter((s) => {
                        return s.studentId === submission.studentId;
                    }).sort((a,b)=>{
                        // newest first                       
                        return new Date(b.createdAt) - new Date(a.createdAt);                    
                    });
                    if (studentSubmissions.length) {
                        const latestSubmission = studentSubmissions[0];    
                        latestSubmission.newFeedback = submission.newFeedback;
                        submission.assignmentName = assignment.name;
                        await this.uploadFeedback(latestSubmission);                    
                    }    
                    else {
                        toastr.error('Student has only one submission this week, please submit normally');
                    }                                                       
                }
                
            } else {
                await this.uploadFeedback(submission);
            }
            this.uploading = false;
            this.getSubmissions();
        },
        downloadRecording(submission) {
            const blob = submission.newFeedback.blob;
            const assignment = this.assignments.find(a => a.id === submission.assignmentId);

            
            let filename = assignment.name + ' Week ' + assignment.week + ' ' + submission.student.firstName + ' ' + submission.student.lastName + '-feedback.' + (submission.newFeedback.type === 'video/mp4' ? 'mp4' : 'webm');
            filename = filename.replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g, '_');           
            
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        },
        async submitGradeOnlyFeedback() {
            
            
            if (this.gradeOnlyFeedback.grade === null || this.gradeOnlyFeedback.grade === undefined || this.gradeOnlyFeedback.grade === '') {
                toastr.error('Please enter a grade');
                return;
            }

            if (this.gradeOnlyFeedback.grade < 0 || this.gradeOnlyFeedback.grade > 100) {
                toastr.error('Grade must be between 0 and 100');
                return;            
            }

            const submission = this.gradeOnlyFeedback.submission;

            const feedbackData = {                
                assignmentId: submission.id,
                populiId: submission.assignmentId.toString(),
                studentId: submission.studentId,
                instructorId: localStorage.account_id,
                courseId: submission.instanceId,
            }

            if (this.gradeOnlyFeedback.videoType === 'placeholderVideo') {
                feedbackData.body = 'https://ttto-utility-bucket.s3.amazonaws.com/grade-placeholder.mp4';
            } else {
                // get the most recent feedback for this submission and use its video as the feedback video
                const recentFeedback = submission.feedbacks && submission.feedbacks.length > 0 ? submission.feedbacks[0] : null;
                if (recentFeedback) {
                    feedbackData.body = recentFeedback.body;
                } else {
                    feedbackData.body = 'https://ttto-utility-bucket.s3.us-west-2.amazonaws.com/grade-placeholder.mp4';
                }
            }

             const grade = {
                assignmentId: submission.id,
                studentId: submission.studentId,
                instanceId: submission.instanceId,
                grade: this.gradeOnlyFeedback.grade
            }
            
            try {
                await axios.request({
                    method: 'POST',
                    url: window.apiUrl + '/feedback',
                    data: feedbackData,
                    headers: { 'Authorization': 'Bearer ' + localStorage.token }
                });

                await axios.request({
                    method: 'PATCH',
                    url: window.apiUrl + '/assignment/' + submission.id,
                    data: grade,
                    headers: { 'Authorization': 'Bearer ' + localStorage.token }
                });

                this.gradeOnlyFeedback = {
                    submission: null,
                    videoType: 'placeholderVideo',
                    grade: null
                };

                toastr.success('Grade submitted successfully');

                this.getSubmissions();

            } catch(e) {
                console.log(e);
                toastr.error('Error submitting grade');                
            }

            console.log(feedbackData)
            console.log(grade)


        },
        async uploadFeedback(submission) {
            const submissionGrade = submission.newFeedback.grade;

            let assignmentName = 'Assignment';

            if (!submission.assignmentName) {
                const assignment = this.assignments.find((a)=>{
                    return a.id === submission.assignmentId;
                });    
                submission.assignmentName = assignment ? assignment.name : 'Assignment';            
            }
            
            
            const ext = submission.newFeedback.blob.type === 'video/mp4' ? 'mp4' : 'webm';

            let filename = assignmentName + ' ' + submission.student.firstName + ' ' + submission.student.lastName;
            filename = filename.replace(/[^a-zA-Z0-9]/g, '').replace(/ /g, '');
            filename = filename + '_' + Math.floor(Math.random() * (999 - 100 + 1) + 100) + '.' + ext;

            if (window.location.hostname !== 'portal.tttc.ca') {
                filename = 'dev-' + filename;
            }

            const file = new File(
                [submission.newFeedback.blob],
                filename,
                {
                    type: submission.newFeedback.blob.type
                }
            );
            const bucket = 'ttto-feedback';

            const signature = await aws.signature(
                file,
                filename,
                bucket,                
            );
            const presignedUrl = await aws.getPresignedUrl(
                this,
                bucket,
                filename,
                'putObject',
            );
            const res = await aws.upload(
                file,
                filename,
                signature,
                bucket,
                presignedUrl.data                
            );
            
            if (!res.success) {
                toastr.error('Error uploading feedback');
                return;
            }


            const feedbackData = {
                body: res.url,
                assignmentId: submission.id,
                populiId: submission.assignmentId.toString(),
                studentId: submission.studentId,
                instructorId: localStorage.account_id,
                courseId: submission.instanceId,
            }


            const grade = {
                assignmentId: submission.id,
                studentId: submission.studentId,
                instanceId: submission.instanceId,
                grade: submissionGrade
            }

          
            try {
                await axios.request({
                    method: 'POST',
                    url: window.apiUrl + '/feedback',
                    data: feedbackData,
                    headers: { 'Authorization': 'Bearer ' + localStorage.token }
                });

                await axios.request({
                    method: 'PATCH',
                    url: window.apiUrl + '/assignment/' + submission.id,
                    data: grade,
                    headers: { 'Authorization': 'Bearer ' + localStorage.token }
                });

                // Clean up blob, object URL, and IndexedDB entry to free memory
                if (submission.newFeedback) {
                    URL.revokeObjectURL(submission.newFeedback.body);
                    submission.newFeedback = null;
                }
                await feedbackStorage.deleteFeedback(submission.id);

                return true;
            } catch(e) {
                console.log(e);
                toastr.error('Error submitting feedback');
                return false;
            }

        },
        getSupportedMimeType() {
            const types = [
                'video/mp4',
                'video/webm;codecs=vp9,opus',
                'video/webm;codecs=vp8,opus',
                'video/webm',
            ];

            for (const type of types) {
                if (MediaRecorder.isTypeSupported(type)) {
                    return type;
                }
            }
            return 'video/webm';
        },
        async checkCameraPermission() {
            try {
                const result = await navigator.permissions.query({ name: 'camera' });
                
                if (result.state === 'prompt') {
                    try {
                        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                        stream.getTracks().forEach(track => track.stop());
                        this.mediaDevices.cameraPermissionGranted = true;
                        return true;
                    } catch (error) {
                        if (error.name === 'NotAllowedError') {
                            toastr.error('Camera access was denied. Please enable camera permissions in your browser settings.');
                        } else if (error.name === 'NotFoundError') {
                            this.noCamera = true;
                            toastr.error('No camera device found. Please connect a camera and try again.');
                        }
                        this.mediaDevices.cameraPermissionGranted = false;
                        return false;
                    }
                } else if (result.state === 'denied') {
                    toastr.error('Camera access is denied. Please enable camera permissions in your browser settings.');
                    return false;
                } else {
                    this.mediaDevices.cameraPermissionGranted = result.state === 'granted';
                    return this.mediaDevices.cameraPermissionGranted;
                }
            } catch (error) {
                toastr.error('Unable to check camera permissions.');                
                return false;
            }
        },
        async startRecording () {
            if (!this.screenPermissionGranted) {
                toastr.error('Please select a video source to start recording.');
                return;
            }
            if (!this.mediaDevices.microphonePermissionGranted) {
                toastr.warning('Warning: you are recording without audio');
            }

            if (this.isRecording) return;
            if (!this.mediaDevices.currentStream) return;

            // Combine video from display with audio from selected microphone
            let stream = this.mediaDevices.currentStream;

            if (this.mediaDevices.selectedAudioSource) {
                try {
                    const audioStream = await navigator.mediaDevices.getUserMedia({
                        audio: {
                            deviceId: { exact: this.mediaDevices.selectedAudioSource.deviceId },
                        },
                    });

                    if (audioStream) {
                        const videoTrack = this.mediaDevices.currentStream.getVideoTracks()[0];
                        const audioTrack = audioStream.getAudioTracks()[0];
                        stream = new MediaStream([videoTrack, audioTrack]);
                        console.log('Recording with audio from:', this.mediaDevices.selectedAudioSource.label);
                    }
                } catch (audioError) {
                    console.error('Error accessing audio device:', audioError);
                    toastr.error('Could not access the selected audio device. Recording without audio.');
                }
            }

            this.isRecording = true;
            this.recordingTime = 0;

            recordingTimer = window.setInterval(() => {
                if (this.isRecording) {
                    this.recordingTime += 1;
                }
            }, 1000);

            const mimeType = this.getSupportedMimeType();
            console.log('Using MIME type for recording:', mimeType);

            const options = {
                mimeType,
                videoBitsPerSecond: 5000000, // 5 Mbps for high quality
            };

            this.mediaRecorder = new MediaRecorder(stream, options);
            this.chunks = [];

            this.mediaRecorder.ondataavailable = (e) => {
                if (e.data.size > 0) this.chunks.push(e.data);
            };

            this.mediaRecorder.onstop = async () => {
                const blob = new Blob(this.chunks, { type: mimeType });
                this.recordedBlob = blob;

                const student = this.students.find((s) => {
                    return s.studentId === this.selectedSubmission.studentId;
                });
                const submission = student.submissions.find((sub) => {
                    return sub.id === this.selectedSubmission.id;
                });

                submission.newFeedback = {
                    body: URL.createObjectURL(this.recordedBlob),
                    type: mimeType,
                    blob: this.recordedBlob,
                    grade: null
                };

                // Save to IndexedDB for persistence across page refreshes
                try {
                    await feedbackStorage.saveFeedback(
                        submission.id,
                        student.studentId,
                        this.recordedBlob,
                        mimeType
                    );
                } catch (error) {
                    console.error('Error saving feedback to IndexedDB:', error);
                }

                this.selectedSubmission = null;
            };

            this.mediaRecorder.onerror = (_event) => {
                const error = new Error('Recording failed');
                console.error('Recording error:', error);
            };

            try {
                this.mediaRecorder.start();
            } catch (error) {
                this.isRecording = false;
                if (recordingTimer) {
                    clearInterval(recordingTimer);
                    recordingTimer = null;
                }
                console.error('Recording start error:', error);
            }
        },

        stopRecording() {
            if (!this.mediaRecorder) return;

            // Check if MediaRecorder is in a state that can be stopped
            if (this.mediaRecorder.state === 'inactive') return;

            this.mediaRecorder.stop();
            if (recordingTimer) {
                clearInterval(recordingTimer);
                recordingTimer = null;
            }
            this.isRecording = false;
            this.isPaused = false;
            console.log('Recording stopped');
        },

        pauseRecording() {
            if (!this.mediaRecorder) return;

            // Can only pause if currently recording
            if (this.mediaRecorder.state !== 'recording') return;

            this.mediaRecorder.pause();
            if (recordingTimer) {
                clearInterval(recordingTimer);
                recordingTimer = null;
            }
            this.isPaused = true;
            this.isRecording = false;
            console.log('Recording paused');
        },

        resumeRecording() {
            if (!this.mediaRecorder) return;

            // Can only resume if currently paused
            if (this.mediaRecorder.state !== 'paused') return;

            this.mediaRecorder.resume();
            recordingTimer = window.setInterval(() => {
                if (this.isRecording) {
                    this.recordingTime += 1;
                }
            }, 1000);
            this.isPaused = false;
            this.isRecording = true;
            console.log('Recording resumed');
        },

    },
    watch: {

    },
    computed: {

        termIsOngoing() {
            const termId = this.selected.term;
            if (!this.terms) return false;

            const term = this.terms.find((t) => t.id === termId);
            if (!term || !term.startDate || !term.endDate) return false;

            const now = new Date();
            const startDate = new Date(term.startDate);
            const endDate = new Date(term.endDate);

            return now >= startDate && now <= endDate;
        },        
    }
}
</script>

<style lang="scss" scoped>
    .disabled-overlay {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background:rgba(0,0,0,.9);
        z-index:9999999;
        display:flex;
        flex-direction:column;
        align-items: center;
        justify-content:center;
        .box {
            background:#444;
            padding:2rem;
            border-radius:4px;
            display:flex;
            flex-direction:column;

        }
    }

    .panel.relative {
        position: relative;
    }

    .panel-heading {
        button {
            background:#3cf;
            color: #222;
            font-size:1.5rem;
            height:auto;
            display:inline-flex;
            line-height:1.5em;
            border:none;
            padding:.25rem .5rem;
            margin-left:1rem;
            border-radius:4px;
            font-weight:500;
            &:disabled {
                cursor:not-allowed;
                opacity:.65;
            }
        }
        h2 {
            display:flex;
            align-items:center;
        }
        .fa-spinner {
            font-size:2rem;
        }
        .download-buttons {
            display:flex;
        }
        a.instructions {
            margin-left:.5rem;            
        }
    }
    .student-header {
        a {
            color: #fafafa;
        }
    }
    .supervisor-comment {
        margin-bottom:2rem;
        textarea {
            margin-bottom:1rem;
            height:180px;
        }
    }

    .download-progress-wrapper {
        display: inline-flex;
        align-items: center;
        margin-left: 1rem;
        gap: 0.5rem;

        &.submission-download {
            margin-left: 0;

            .download-stage {
                font-size: 1.2rem;
                width:75px;
            }

            .download-progress {
                width: 120px;
                height: 12px;
                margin-top:2px;
            }

            .download-progress-text {
                font-size: 1rem;
            }
        }
    }

    .download-stage {
        font-size: 1.4rem;
        font-weight: 500;
        color: #3cf;
    }

    .download-progress {
        display: inline-flex;
        align-items: center;
        width: 360px;
        height: 16px;
        background: #444;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
    }

    .download-progress-bar {
        height: 100%;
        background: #3cf;
        transition: width 0.2s ease;
    }

    .download-progress-text {
        position: absolute;
        width: 100%;
        text-align: center;
        font-size: 1.2rem;
        font-weight: 500;
        color: #fff;
        text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
    }

    .feedback {
        padding-top: 2rem!important;
    }
    .assignments {
        margin-top:2rem;
    }
    ul.students {
        padding: 0 2rem;
        margin-top:2rem;
        li.student {
            margin-bottom: 2rem;
            border-bottom: 1px solid #ccc;
            padding-bottom: 1rem;

        }
    }
    .student-submission {
        display: flex;
        align-items:center;
        justify-content:space-between;
        margin-bottom:2rem;       
    }
    .fa-spinner {
       color: #33ccff;
        font-size:1.5rem;
        animation: spin 2s linear infinite;        
    }
    .feedback-buttons span {
        display:flex;
        flex-direction:column;
    }
    .urls {
        display:inline-flex;
        align-items:center;
        gap:1rem;
        max-width:800px;
        flex-wrap:wrap;
    }
    .submission {
        display:flex;
        flex-direction:column;
        gap:.5rem;
        .video-buttons {
            display:inline-flex;
            gap:.75rem;
            margin-left:.5rem;
        }
        label.file-upload {
            cursor:pointer;
            margin:0;
            top:0;
        }
        
        .fa-comments.open {
            color:rgb(63, 235, 155);


        }
    }
    .control-btn {
        font-size:12px;
        padding:.25rem 1rem;
        border-radius:4px!important;
        line-height:auto!important;
    }
    .audio-source {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .75);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999999;
    }
    .audio-source-modal {
        background: #444;
        padding: 2rem;
        border-radius: 4px;
        width: 500px;
        max-width: 90%;
        display: flex;
        flex-direction: column;
        gap: 2rem;

    }
     .audio-source-item {
        background:#555;
        border-radius:4px;
        padding: 1rem;
        display: flex;
        align-items: center;
        gap: 1rem;
        cursor: pointer;
        transition: all 0.2s ease;

        i.ri-mic-line {
            font-size: 20px;
            
        }

        span {
            flex-grow: 1;
        }

        i.ri-check-line {
            font-size: 20px;
           
        }

        &:hover {
            background: #666;
        }

        &.selected {
            border: 1px solid #888;
        }
    }

    .recording-indicator {
        width:12px;
        height:12px;
        background:red;
        display:inline-flex;
        border-radius:50%;
        animation: pulse 2s infinite;
        margin-top:2px;
    }
    @keyframes pulse {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            transform: scale(1.5);
            opacity: 0.5;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }


    .recorder {
        position: fixed;
        background:#333;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999999;
        display: flex;
        flex-direction: column;
        .recording {
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: center;           
        }
        .recording.is-recording {
            video {
                border:2px solid red;
            }
        }
        .recording.paused {
            video {
                border: 2px solid green;
            }
        }
        .controls {
            padding: 1rem;
            display:flex;
            align-items:center;
            justify-content:space-between;
            .left {
                gap: 1rem;
            }
            .right {
                .button {
                    gap: 1rem;
                }
            }
            .btn {
                i {
                    margin-right:.5rem;
                }
            }
        }
        video {
            height: 100%;
            max-height: calc(100vh - 120px);
        }        
    }
    .btn-error {
        background:red;
        color:#fff;
    }
    .new-feedback-wrapper, .grade-only-feedback {
        display:flex;
        flex-direction: column;
        gap:1rem;
        align-items:flex-start;
        margin-bottom:1rem;
         border:1px solid #555;
        padding:1rem;
        border-radius:4px;
        .buttons {
            display:flex;
            gap:1rem;
            button {
                border:none;
            }
        }
        input:not([type="radio"]):not([type="checkbox"]) {
            width:200px;
        }
    }
    .new-feedback-wrapper {
        .checkbox-wrapper {
            display:flex;
            align-items:center;
            gap: 1rem;
            input {
                width:18px;
                height:18px;
                position:relative;
                top:-2px;
                cursor:pointer;
            }
        }
    }

    .grade-only-feedback {
       

        .radio-inputs {
            display:flex;
            align-items:center;
            gap:1rem;

            input[type="radio"] {
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
                width: 16px;
                height: 16px;
                border: 2px solid #3cf;
                border-radius: 50%;
                background: transparent;
                cursor: pointer;
                position: relative;
                margin-right: 0.5rem;
                margin-top:0;

                &:checked::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: #3cf;
                }
            }

            label {
                display: flex;
                align-items: center;
                cursor: pointer;
                margin: 0;
            }
        }
    }
    .new-feedback {
        height: 240px;
        margin-top: 1rem;
        width:360px;
        object-fit:contain;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    .recording-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: .5rem;
    }
    .recording-frame {
        border:1px dashed #b0b0b0;
        margin:4rem;

    }
    .no-students h4 {
        padding:1rem;
        margin:6rem .5rem;
    }
    .file-upload {
        color: #3cf;
    }
    .upload-all-wrapper {
        padding-left:2rem;
        margin-bottom:2rem;
    }
    .comments-box {
        background:#2b2b2b;
        white-space: pre-wrap;        
        padding:1rem;
        border-radius:4px;
        border:1px solid #555;
        margin-bottom:2rem;
    }
    .no-assignments {
        margin-top:2.5rem;
    }
</style>


// WEBPACK FOOTER //
// Feedback.vue?08dd012c